var map = {
	"./arrow-down-blue.svg": 465,
	"./arrow-down-grey.svg": 466,
	"./arrow-right-white.png": 467,
	"./arrow-right.svg": 468,
	"./avalanche-logo.png": 187,
	"./big_unicorn.png": 241,
	"./binance-coin-logo.png": 188,
	"./blue-loader.svg": 242,
	"./circle-grey.svg": 469,
	"./circle.svg": 470,
	"./coinbaseWalletIcon.svg": 151,
	"./dropdown-blue.svg": 471,
	"./dropdown.svg": 472,
	"./dropup-blue.svg": 473,
	"./ethereum-logo.png": 110,
	"./fantom-logo.png": 189,
	"./fortmaticIcon.png": 152,
	"./heco-logo.png": 190,
	"./link.svg": 474,
	"./magnifying-glass.svg": 475,
	"./matic-logo.png": 191,
	"./menu.svg": 476,
	"./metamask.png": 240,
	"./moonbeam-logo.png": 192,
	"./noise.png": 243,
	"./one.png": 193,
	"./plus-blue.svg": 477,
	"./plus-grey.svg": 478,
	"./portisIcon.png": 153,
	"./question-mark.svg": 479,
	"./question.svg": 480,
	"./spinner.svg": 481,
	"./token-list/lists-dark.png": 482,
	"./token-list/lists-light.png": 483,
	"./token-logo.png": 156,
	"./trustWallet.png": 484,
	"./walletConnectIcon.svg": 154,
	"./x.svg": 485,
	"./xdai-logo.png": 244,
	"./xl_uni.png": 245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;